const APP_VERSION = process.env.PACKAGE_VERSION;

export default APP_VERSION;
